import React from 'react';
import './card-notification.css'


const Cardnotification = (props) => {
    return ( 
        <article className='card-sec2-p2'>
                <figure className='img-cont-card-sec2-p2'>
                    <img className='icon-notification' src={props.img} alt={props.alt}></img>
                </figure>

                <article className='container-info-card-sec2-p2'>

                    <article className='text-cont-sec2-p2'>
                        <h1 className='header-sec2-p2'>{props.title}</h1>
                        <h3 className='paragraph-sec2-p2'>{props.para}</h3>
                        <p className='time-sec2-p2'>{props.time}</p>
                    </article>

                    <div className='line-card-sec2-p2'></div>

                </article>
        </article>
     );
}
 
export default Cardnotification;